import e from"./RefinementList.vue_vue&type=script&lang.js";import{render as t}from"./RefinementList.vue_vue&type=template&id=80c1baee&lang.js";e.render=t;export default e;
//# sourceMappingURL=RefinementList.vue.js.map
